import { render, staticRenderFns } from "./LinksPage.vue?vue&type=template&id=9f981e36&scoped=true&"
import script from "./LinksPage.vue?vue&type=script&lang=js&"
export * from "./LinksPage.vue?vue&type=script&lang=js&"
import style0 from "./LinksPage.vue?vue&type=style&index=0&id=9f981e36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f981e36",
  null
  
)

export default component.exports